var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dividends-success container container_30" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "dividends-success__title" }, [
        _vm._v(_vm._s(_vm.i18n.divid_success_title()))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dividends-success__sub-title" }, [
        _vm._v(_vm._s(_vm.i18n.divid_success_sub_title()))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dividends-success__text" }, [
        _vm._v(_vm._s(_vm.i18n.divid_success_text()))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-wrap margin-top" },
        [
          _c(
            "md-button",
            { staticClass: "btn md-primary", attrs: { to: "/history" } },
            [_vm._v(_vm._s(_vm.i18n.lbl_history()))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dividends-success__icon" }, [
      _c("div", { staticClass: "icon__circle" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f1c9792", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f1c9792","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/components/DividendsPageSuccess.vue
// module id = gogC
// module chunks = 1